// TypingIndicator.jsx
import React from 'react';
import '../styles/TypingIndicator.css';

const TypingIndicator = ({ usernames }) => {
  return (
    <div className="typing-indicator-container">
      <div className="typing-bubble">
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
      </div>
        {usernames?.map((user, id) => (
            <span key={user + "" + id} className="typing-username">{user} is typing...</span>
        ))}
    </div>
  );
};

export default TypingIndicator;
